import cn from "classnames";
import { Media } from "components";
import { useTranslation } from "react-i18next";

import { InventoryProductVariantProps } from "./InventoryProductVariant.types";

import styles from "./InventoryProductVariant.module.scss";

const InventoryProductVariant = ({
  productVariant,
  type = "sm"
}: InventoryProductVariantProps) => {
  const { t } = useTranslation();
  const isLg = type === "lg";

  return (
    <div className={styles.damagedProduct}>
      {productVariant.image && (
        <div
          className={cn(styles.damagedProduct_imageThumb, {
            [styles.damagedProduct_imageThumbBg]: isLg
          })}
        >
          <Media
            className={styles.damagedProduct_image}
            mediaFile={productVariant.image}
          />
        </div>
      )}
      <div className={styles.damagedProduct_content}>
        <div
          className={cn(styles.damagedProduct_name, {
            [styles.damagedProduct_nameBg]: isLg
          })}
        >
          {productVariant.name}
        </div>
        <div
          className={cn(styles.damagedProduct_info, {
            [styles.damagedProduct_infoBg]: isLg
          })}
        >
          <span>{productVariant.categoryName}</span>·
          <span>{t(productVariant.colorValue)}</span>·
          <span>{productVariant.sizeValue}</span>
        </div>
        <div
          className={cn(styles.damagedProduct_sku, {
            [styles.damagedProduct_skuBg]: isLg
          })}
        >
          SKU: {productVariant.sku}
        </div>
        {isLg && (
          <div className={styles.damagedProduct_barcode}>
            {t("Barcode")}: {productVariant.barcodeValue}
          </div>
        )}
      </div>
    </div>
  );
};

export default InventoryProductVariant;
